import React, {useRef} from "react";
import classNames from "classnames";
import {useSelector} from "react-redux";
import CountUp from 'react-countup';

import {textMap} from "../common/Localization";

import './UserStat.scss';

const UserStat = () => {
	const id = useSelector(state => state.ScrollModule.id);

	const showStat = useRef();
	if(!showStat.current && id === "userStat") {
		showStat.current = true;
	}

	return (
		<div id="userStat" className="bc_blue view_section">
			<div className="user_stat_wrap">
				<div className={classNames("title", "c_light_blue_2")}>{textMap.formatString(textMap.user_stat_title, <span className="c_ff">{textMap.user_stat_title_2}</span>)}</div>
				<div className="stat_wrap">
					<div className={classNames("stat", "c_light_blue_2")}>
						{
							textMap.formatString(textMap.user_stat_desc_1, 
								<span className={classNames("c_ff", "stat_value")}>
									{textMap.formatString(textMap.user_stat_value_1, showStat.current ? <CountUp end={39.4} duration={1.5} decimals={1}/> : 0)}
								</span>
							)
						}
					</div>
					<div className={classNames("stat", "c_light_blue_2")}>
						{
							textMap.formatString(textMap.user_stat_desc_2, 
								<span className={classNames("c_ff", "stat_value")}>
									{textMap.formatString(textMap.user_stat_value_2, showStat.current ? <CountUp end={80000} duration={2} formattingFn={(number => number.toLocaleString())}/> : 0)}
								</span>
							)
						}
					</div>
					<div className={classNames("stat", "c_light_blue_2")}>
						{
							textMap.formatString(textMap.user_stat_desc_3, 
								<span className={classNames("c_ff", "stat_value")}>
									{textMap.formatString(textMap.user_stat_value_3, showStat.current ? <CountUp end={412000} duration={2.5}  formattingFn={(number => number.toLocaleString())}/> : 0)}
								</span>
							)
						}
					</div>					
				</div>
				<div className={classNames("info", "c_light_blue_2")}>{textMap.user_stat_info}</div>
			</div>
		</div>
	);
};

export default UserStat;
